import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('keydown', this.#handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('keydown', this.#handleKeydown);
    super.disconnectedCallback();
  }

  /**
   * ETOLIE 02.09.2026 — Enter w polu ilości zatwierdza ilość, nie wysyła formularza.
   * Pole `updates[]` leży w `<form id="cart-form">`, którego jedynym submitem jest
   * „Przejdź do płatności" (`snippets/cart-summary.liquid`), więc domyślne wysłanie
   * formularza (implicit submission) wyrzucało klientkę prosto do kasy zamiast
   * zapisać nową ilość. Dotyczy tylko koszyka; na PDP Enter ma działać jak dotąd,
   * dlatego obsługa jest tutaj, a nie w klasie bazowej.
   * @param {KeyboardEvent} event - The keydown event.
   */
  #handleKeydown = (event) => {
    if (event.key !== 'Enter' || event.target !== this.refs.quantityInput) return;

    event.preventDefault();
    this.setQuantity(event);
  };

  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    // Cart buttons are always dynamically managed
    minusButton.disabled = value <= min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
